import React, { useEffect, useState } from "react";
import ImageBox from "./ImageBox";

export default function PagesShow({
  imageSrc,
  imageAlt,
  centered,
  leftChildren,
}) {
  const [ext, setExt] = useState(null);
  useEffect(() => {
    if(imageSrc) setExt(/[^.]+$/.exec(imageSrc)[0]);
  }, [imageSrc]);
  return (
    <>
      {imageSrc && ext && (
        <>
          {["webm", "mp4"].includes(ext) ? (
            <div className="side video">
              <video autoPlay loop className="video-box">
                <source src={imageSrc} type="video/webm" />
              </video>
            </div>
          ) : (
            <div className="side image">
              <ImageBox image={imageSrc} alt={imageAlt} />
            </div>
          )}
        </>
      )}
      <div className={`side data ${centered ? "centered" : ""}`}>
        {leftChildren}
      </div>
    </>
  );
}
